import { render, staticRenderFns } from "./CreateFreeComponent.vue?vue&type=template&id=07a35b80&"
import script from "./CreateFreeComponent.vue?vue&type=script&lang=js&"
export * from "./CreateFreeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports